import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => { 
    var list = request({
        url: 'comGoodsDoc/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const downOrderExcel = query => { 
    var list = request({
        url: 'comGoodsDoc/getGoodsDocExcel.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const fetchSelect = query => { 
    var list = request({
        url: 'comGoods/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 